import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dw-static-record-marker__container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.5 5L1.5 1H9.5L5.5 5Z",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_marker_state = _resolveComponent("dw-marker-state")!

  return (_openBlock(), _createElementBlock("div", {
    class: "dw-static-record-marker",
    style: _normalizeStyle({ borderColor: _ctx.computedColor })
  }, [
    (_ctx.state === 1)
      ? (_openBlock(), _createBlock(_component_dw_marker_state, {
          key: 0,
          class: "dw-static-record-marker__state",
          type: "green"
        }))
      : _createCommentVNode("", true),
    (_ctx.waitListStatus !== null)
      ? (_openBlock(), _createBlock(_component_dw_marker_state, {
          key: 1,
          class: "dw-static-record-marker__state",
          type: "purple"
        }))
      : _createCommentVNode("", true),
    (_ctx.delaying)
      ? (_openBlock(), _createBlock(_component_dw_marker_state, {
          key: 2,
          class: "dw-static-record-marker__state",
          type: "red"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "dw-static-record-marker__header",
      style: _normalizeStyle({ backgroundColor: _ctx.computedColor })
    }, _toDisplayString(_ctx.orderNumber), 5),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.timeSlot), 1),
    (_openBlock(), _createElementBlock("svg", {
      class: "dw-static-record-marker__anchor",
      style: _normalizeStyle({ color: _ctx.computedColor }),
      width: "11",
      height: "6",
      viewBox: "0 0 11 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_3, 4))
  ], 4))
}